import { Component, OnInit } from '@angular/core';
import { DashboardService } from '../../dashboard/dashboard.service';
import { SessionStorage } from 'ngx-webstorage';
import { Observable } from 'rxjs/Observable';
import { DeligateService } from '../../deligate/deligate.service';
import { TimesheetApprovalsService } from '../timesheet-approvals.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-approval-list',
  templateUrl: './approval-list.component.html',
  styleUrls: ['./approval-list.component.css']
})
export class ApprovalListComponent implements OnInit {
  @SessionStorage() public user;
  @SessionStorage() public config;
  public approveList: any = [];
  public empListarray: any = [];
  public temporaryList: any = [];
  public userfilterproject: any = { Employee: '' };
  public role: string = 'EMP';
  public filteredOptions: Observable<string[]>;
  public dateRange: any = [];
  public daysList: any = [];
  constructor(
    public dashboardService: DashboardService,
    public deligateService: DeligateService,
    public timesheetApprovalsService: TimesheetApprovalsService,
    public router: Router
  ) { }

  ngOnInit() {
    this.getrmLockLists();
    this.getempList(this.role);
  }

  /**function to get employee list */
  getempList(role) {
    this.empListarray = [];
    this.deligateService.getempList('').subscribe(
      (response) => {
        response.payload.forEach(value => {
          if (value.Empno !== this.user.Empno) {
            this.empListarray.push(value);
          }
        });
      });
  }

  /**function to filter entities*/
  filterEntities(event: any) {
    const searchItem = event.target.value;
    if (event.target.value !== 'undefined') {
      this.filteredOptions = this.empListarray.filter(s => s.Empname.toLowerCase().indexOf(searchItem.toLowerCase()) == 0);
    } else {
      this.approveList = this.temporaryList;
    }
  }

  /**function to select employee*/
  employeeSelected(option) {
    this.approveList = [];
    this.temporaryList.forEach(element => {
      if (element.userDetails.Empno == option.Empno) {
        this.approveList.push(element);
      }
    });
  }

  /**function to get emplyee locked list*/
  getrmLockLists() {
    this.approveList = [];
    const obj = {
      'userDetails': {
        'Empno': this.user.Empno
      }
    };
    this.dashboardService.getDashboard(obj).subscribe(
      (data) => {
        if (data.payload.pendingTimesheetList) {
          data.payload.pendingTimesheetList.forEach((value, i) => {
            this.daysList[i] = [];
            this.temporaryList.push(value);
            this.approveList.push(value);
            const year = new Date().getFullYear();
            const week = value.weekNumber;
            const n1 = this.getStartDateWeek(week, value.timesheetList[0].dateDetails.Year); // change year variable
            const n2 = this.getEndDateWeek(week, value.timesheetList[0].dateDetails.Year); // change year variable
            this.dateRange.push(n1 + ' - ' + n2);
            value.timesheetList.forEach(element => {
              const date = element.dateDetails.date;
              const dayOfWeek = new Date(date).getDay();
              const days = (isNaN(dayOfWeek)) ? null : ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'][dayOfWeek];
              if (!this.daysList[i].includes(days)) {
                this.daysList[i].push(days);
              }
            });
          });
        }
      });

  }

  /**function to set start date*/
  getStartDateWeek(w, y) {
    const checkDate = new Date(y, 0, 1 + (w - 1) * 7);
    const dow = checkDate.getDay();
    const weekStart = checkDate;
    if (this.config.businessUnit !== 'accenture') {
      if (dow <= 4) {
        weekStart.setDate(checkDate.getDate() + 1 - checkDate.getDay() + 0);
      } else {
        weekStart.setDate(checkDate.getDate() + 1 + 8 - checkDate.getDay());
      }
    } else {
      if (dow <= 4) {
        weekStart.setDate(checkDate.getDate() - checkDate.getDay() + 0);
      } else {
        weekStart.setDate(checkDate.getDate() + 8 - checkDate.getDay());
      }
    }
    return weekStart.toLocaleDateString();
  }

  /**function to set end date*/
  getEndDateWeek(w, y) {
  const checkDate = new Date(y, 0, 1 + (w - 1) * 7);
  const dow = checkDate.getDay();
  const weekStart = checkDate;
  if (this.config.businessUnit !== 'accenture') {
  if (dow <= 4) {
    weekStart.setDate(checkDate.getDate() + 1 - checkDate.getDay() + 6);
  } else {
    weekStart.setDate(checkDate.getDate() + 1 + 8 - checkDate.getDay());
  }
   } else {
    if (dow <= 4) {
      weekStart.setDate(checkDate.getDate() - checkDate.getDay() + 6);
    } else {
      weekStart.setDate(checkDate.getDate() + 8 - checkDate.getDay());
    }
  }
  return weekStart.toLocaleDateString();
  }

  /**function to get timesheet based on weeknumber*/
  timeSheet(row, weekNumber) {
    const data = {
      'employeenumber': row.userDetails.Empno
    };
    const year = row.timesheetList[0].dateDetails.Year ?  row.timesheetList[0].dateDetails.Year : new Date().getFullYear();
    this.timesheetApprovalsService.setSelectedRowData(data, weekNumber, year);
    this.router.navigate(['rm/viewtimesheetDetails']);
  }

}



// WEBPACK FOOTER //
// ./src/app/rm/timesheet-approvals/approval-list/approval-list.component.ts